import { sharedStore } from '@ncl/rootStore/rootStore.model';

export const PRIVACY_KEY = 'privacy';
export const LIABILITY_KEY = 'liability';
export const RESOLUTION_382_KEY = 'resolution-382';

export function getInitialStatus() {
  const obj = {};
  if (sharedStore.currentLiabilityTerms) {
    obj[LIABILITY_KEY] = false;
  }

  if (sharedStore.currentPrivacyTerms) {
    obj[PRIVACY_KEY] = false;
  }

  if (sharedStore.currentResolution382Terms) {
    obj[RESOLUTION_382_KEY] = false;
  }
  return obj;
}

export function validateAcceptance(status, errors, setErrors) {
  const keys = Object.keys(getInitialStatus());
  const termsErrors = errors;

  keys.forEach((k) => {
    if (!status[k]) {
      termsErrors[k] = true;
    } else {
      delete termsErrors[k];
    }
  });

  setErrors({ ...termsErrors });
  if (Object.keys(termsErrors).length > 0) {
    return false;
  }

  return true;
}
